export default __webpack_public_path__ + "static/media/resize_icon.54862408.svg";